import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  partners: [],
  operations: [],
  expirations: [],
  selectedOperation: {},
  partnersForSelect: [],
  partnersThemes: [],
  partnerInfo: {}
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
